export const violet = "#471E51"
export const lavendar = "#CEC0F9"

